export default __webpack_public_path__ + "static/media/cloud.afaf29aa.svg";